import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Button, Card, Col, Empty, Row, Select, Spin, Table, Tag } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons";
import { useJobTitles } from "Hooks/AdminHooks/Organization/useJobTitles";

const JobTitles = () => {
  const { departments, loadingDepts, jobTitles, loadingJobs, fetchJobTitles, fetchDepartmentList } =
    useJobTitles();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  useEffect(() => {
    fetchDepartmentList();
  }, []);

  useEffect(() => {
    const loadDepartments = async () => {
      await fetchDepartmentList();

      const deptId = location.state?.departmentId || selectedDepartment;
      if (deptId) {
        setSelectedDepartment(deptId);
        fetchJobTitles(deptId);
      }
    };

    loadDepartments();
  }, [location.state?.departmentId]);

  const handleDepartmentChange = (value) => {
    setSelectedDepartment(value);
    fetchJobTitles(value);
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "publicId",
      key: "publicId",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => {
        const maxLength = 50;
        if (!text) return "-";
        return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
      },
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive) =>
        isActive ? <Tag color="green">Active</Tag> : <Tag color="red">In Active</Tag>,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <Button
          icon={<EditOutlined />}
          style={{ marginRight: 8 }}
          onClick={() => {
            navigate(`/edit-jobtitle/${record.id}`, {
              state: { departmentId: selectedDepartment },
            });
          }}
        />
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-4">
        {/* Header*/}

        <Row className="mb-4" justify="space-between" align="middle">
          <Col>
            <h2 className="fw-bold mb-0">Job Titles</h2>
          </Col>
          <Col>
            <Button className="btn-back" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
              Back
            </Button>
          </Col>
        </Row>

        {/* Department Selection*/}

        <Card>
          <Row justify="space-between" align="middle" gutter={16}>
            <Col xs={24} md={12}>
              <Select
                style={{ width: "100%" }}
                placeholder="Select Department"
                loading={loadingDepts}
                onChange={handleDepartmentChange}
                value={selectedDepartment}
                options={departments?.map((dept) => ({
                  label: dept.name,
                  value: dept.id,
                }))}
              />
            </Col>
            <Col>
              <Button
                className="btn-primary"
                disabled={!selectedDepartment}
                onClick={() =>
                  navigate(`/create-jobtitle/${selectedDepartment}`, {
                    state: { departmentId: selectedDepartment },
                  })
                }
              >
                Add Job Title
              </Button>
            </Col>
          </Row>
        </Card>

        <div className="mt-4">
          {loadingJobs ? (
            <Spin />
          ) : selectedDepartment ? (
            jobTitles && jobTitles.length > 0 ? (
              <Table columns={columns} dataSource={jobTitles} rowKey="id" />
            ) : (
              <Empty description=" No Job Titles found for this Department" />
            )
          ) : (
            <Empty description=" Please select a deartment to view the Job Titles" />
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};
export default JobTitles;
